


const DeleteView = ({handleDeleteCancel,handleDeleteConfirm})=>{
  
    return(
          <div>
             
                 <div className=" fixed inset-0 flex justify-center bg-black  bg-opacity-10 z-50">
                   <div className="bg-white p-6 w-[350px] h-[290px] md:w-[400px] md:h-[300px] rounded-lg shadow-lg text-center  mt-[15%]">
                     <div className=' flex justify-center mt-10 '>
                      <img className='  '  src='\assets\deleteIcon.png'  width={80} height={80} />
                     </div>
                    <div className='mt-5 '>
                     <p className=' text-sm  md:text-black'>Do You want to delete this Folder?</p>
                    </div>
                     <div className="flex justify-between mt-10">
                     <button onClick={handleDeleteCancel} className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400">
                        No,I Cancelled
                       </button>
                       <button onClick={handleDeleteConfirm} className="bg-red-400 text-red-600  font-bold px-4 py-2 rounded ">
                         Delete
                       </button>
                       
                     </div>
                   </div>
                 </div>
             
          </div>
    
    

    )
}
export default DeleteView  